<template>
<v-container fluid>

<v-stepper v-model="step" elevation="0" v-if="initialized">
  <v-stepper-header>
    <v-stepper-step :complete="step > 1" step="1" editable edit-icon="$check" color="primary"></v-stepper-step>
    <v-divider></v-divider>

    <v-stepper-step :complete="step > 2" step="2" :editable="hasCategory" edit-icon="$check" color="primary"></v-stepper-step>
    <v-divider></v-divider>

    <v-stepper-step :complete="step > 3" step="3" :editable="hasCategory" edit-icon="$check" color="primary"></v-stepper-step>
    <v-divider v-if="noContactForm == undefined"></v-divider>

    <v-stepper-step step="4" :complete="sent" v-if="noContactForm == undefined" edit-icon="$check" :editable="hasCategory" color="primary"></v-stepper-step>
  </v-stepper-header>

  <v-stepper-items>
    <v-stepper-content step="1">
      <div class="immoapp__step__content">
        <inquiry-categories
          :category="category" @category="setCategory"
          :marketingType="marketingType" @marketingType="setMarketingType"
          :objectType="objectType" @objectType="setObjectType"
          @next="next"
          :categoryList="config.categoryList"
          inquiryType="lead"
          :icons="true"
        ></inquiry-categories>
      </div>
    </v-stepper-content>

    <v-stepper-content step="2">
      <div class="immoapp__step__content">
        <inquiry-location v-if="step == 2" :defaultCenter="config.mapCenter" :defaultZoom="12"></inquiry-location>
        <!--
        <inquiry-address v-if="step == 2"
          inquiryType="lead"
          :autocompleteText="$t('Bitte geben Sie PLZ / Ort ein')"
          :location="location"
          @update="setLocationFields"
          :defaultMapCenter="config.mapCenter"></inquiry-address>
          -->
      </div>

      <div class="immoapp__step__footer">
        <v-row>
          <v-col cols="6">
            <button class="btn btn-link" type="button" @click="prev"><font-awesome-icon :icon="['far', 'angle-left']" /> {{ $t("zurück") }}</button>
          </v-col>
          <v-col cols="6" class="text-right">
            <button class="btn btn-link" type="button" @click="next">{{ $t("weiter") }} <font-awesome-icon :icon="['far', 'angle-right']" /></button>
          </v-col>
        </v-row>
      </div>
    </v-stepper-content>

    <v-stepper-content step="3">
      <div class="immoapp__step__content">
        <inquiry-fields :fields="selectedFields" :marketing-type="marketingType" @fieldChanged="changeField"></inquiry-fields>
      </div>

      <div class="immoapp__step__footer">
        <v-row>
          <v-col cols="6">
            <button class="btn btn-link" type="button" @click="prev"><font-awesome-icon :icon="['far', 'angle-left']" /> {{ $t("zurück") }}</button>
          </v-col>
          <v-col cols="6" class="text-right">
            <button v-if="noContactForm == undefined" class="btn btn-link" type="button" @click="next">{{ $t("weiter") }} <font-awesome-icon :icon="['far', 'angle-right']" /></button>
          </v-col>
        </v-row>
      </div>
    </v-stepper-content>

    <v-stepper-content step="4" v-if="noContactForm == undefined">
      <div class="immoapp__step__content mt-5">
        <contact-form :requiredFields="requiredFields"
          submitUrl="/v1/contact/lead/411"
          :error="error"
          :errors="errors"
          :sent="sent"
          @error="onError"
          @submit="onSubmit"
        >
          <contact-fields v-if="loggedIn" :outline="false" :exclude="['company', 'contactType', 'message', 'person', 'phone_email']"></contact-fields>
          <contact-fields v-else :outline="false" :exclude="['company', 'contactType', 'message']"></contact-fields>

          <template v-slot:footer="props">
            <v-row align="center">
              <v-col cols="1">
                <button class="btn btn-link" type="button" v-if="!sent" @click="prev"><font-awesome-icon :icon="['far', 'angle-left']" /> {{ $t("zurück") }}</button>
              </v-col>
              <v-col cols="11" class="text-right">
                <button
                  :disabled="props.loading"
                  v-show="!props.sent"
                  type="submit"
                  class="btn btn-primary"
                  >{{ $t('Anfrage abschicken') }}</button>
              </v-col>
            </v-row>

          </template>
        </contact-form>
      </div>

    </v-stepper-content>
  </v-stepper-items>

</v-stepper>
<slot v-if="initialized"></slot>
</v-container>
</template>

<script>
import InquiryCategories from "./InquiryCategories";
//import InquiryAddress from "./InquiryAddress";
import InquiryFields from "./InquiryFields";
import config from "./ConfigLead";
import inquiryFieldsConfig from "./InquiryFieldsConfig";

export default {
  name: "LeadWizard",

  components: {
    InquiryCategories,
    //InquiryAddress,
    InquiryFields
  },

  props: [
    "noContactForm"
  ],

  data() {
    return {
      initialized: false,
      error: false,
      errors: [],
      sent: false,
      marketingType: "BUY",
      objectType: "LIVING",
      category: null,
      step: 1,
      location: null,
      fields: [],
      config
    }
  },

  computed: {
    requiredFields() {
      return this.config.requiredFields;
    },

    loggedIn() {
      return this.$store.state.user.loggedIn;
    },

    inquiry() {
      const inquiry = {};

      if (this.marketingType) {
        inquiry.marketingType = this.marketingType;
      }

      if (this.objectType) {
        inquiry.objectType = this.objectType;
      }

      if (this.category) {
        inquiry.categoryId = this.category.id;
      }

      if (this.location) {
        inquiry.locations = [this.location];
      }

      inquiry.fields = [];
      this.fields.forEach(f => {
        inquiry.fields.push(f.ds);
      });

      return inquiry;
    },

    hasCategory() {
      return !(this.category == null);
    },

    selectedFields() {
      if (this.category) {
        let fieldNames = [];
        config.categoryList.forEach(c => {
          if (c.id == this.category.id) {
            c.fieldList.forEach(f => {
              if (typeof f == "object") {
                fieldNames.push(f.var);
              } else {
                fieldNames.push(f);
              }
            });
          }
        });

        return this.fields.filter(f => {
          return fieldNames.indexOf(f.id) > -1;
        });
      }

      return this.fields;
    }
  },

  created() {
    this.$store.dispatch("loading", true);
    inquiryFieldsConfig(config, this.$store, t => {
        return this.$t(t);
      }).then(fieldsConfig => {
        this.fields = fieldsConfig;

        this.category = this.config.categoryList[0];

        this.initialized = true;
        this.$store.dispatch("loading", false);
      });
  },

  methods: {
    changeField(field, trigger) {
      //const fields = [];
      for (let i = 0; i < this.fields.length; i++) {
        if (this.fields[i].id == field.id) {
          this.fields[i].ds = field.ds;
          this.$set(this.fields, i, Object.assign({}, this.fields[i]));
        }
      }

      if (trigger == undefined || trigger) {
        this.triggerChange();
      }
    },

    prev() {
      this.srolllTop();
      this.step--;
    },

    next() {
      this.srolllTop();
      this.step++;
    },

    srolllTop() {
      if ('parentIFrame' in window) {
        parentIFrame.getPageInfo((info) => {
          let scrollTarget = info.windowHeight * 0.15 * -1;
          parentIFrame.scrollToOffset(0, scrollTarget);
          parentIFrame.getPageInfo(false);
        })
      }
    },

    triggerChange() {
      this.$emit("change", this.inquiry);
    },

    setMarketingType(val) {
      this.marketingType = val;
      this.triggerChange();
    },

    setObjectType(val) {
      this.objectType = val;
      this.category = null;
      this.triggerChange();
    },

    setCategory(val) {
      this.category = val;
      this.triggerChange();
    },

    setLocationFields(list) {
      let l = {};
      if (this.location) {
        l = this.location;
      }
      Object.keys(list).forEach(k => {
        l[k] = list[k];
      });

      this.location = l;

      this.triggerChange();
    },

    onError(v) {
      this.error = v;
    },

    onSubmit(value) {
      this.$store.commit("loading", true);

      const body = {
        address: value.contact,
        lead: this.inquiry
      };

      this.$store.dispatch("ajax", {
        url: "/v1/contact/lead",
        method: "post",
        data: body
      }).then(res => {
        this.error = false;
        if ("error" in res && res.error) {
          this.error = true;
        }

        this.errors = [];
        if ("errors" in res) {
          this.errors = res.errors;
        }

        this.sent = !this.error;
      }).catch((e) => {
        console.log(e);
        this.error = true;
      }).finally(() => {
        this.$store.commit("loading", false);
      });
    }
  }
};
</script>


